import { useState, useEffect } from 'react';
import { getStatsFirstMonitoring } from '../../../../services';

interface UseHospitalStatsDataOptions {
  investigation: { uuid: string };
  startDate: number | null;
  endDate: number | null;
}

export const useHospitalStatsData = ({ investigation, startDate, endDate }: UseHospitalStatsDataOptions) => {
  const [stats, setStats] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!investigation?.uuid || !startDate || !endDate) return;

    let cancelled = false;
    setLoading(true);
    setError(null);

    getStatsFirstMonitoring(investigation.uuid, startDate, endDate)
      .then((response: any) => {
        if (!cancelled) {
          setStats(response);
          setLoading(false);
        }
      })
      .catch((err: Error) => {
        if (!cancelled) {
          setError(err);
          setLoading(false);
        }
      });

    return () => { cancelled = true; };
  }, [investigation?.uuid, startDate, endDate]);

  return { stats, loading, error };
};
